import type IntegrationStore from '@src/service/integration-store'

import {
  BaseLegacyIntegrationModel,
  type BaseLegacyIntegration,
} from './BaseLegacyIntegrationModel'

interface RawSlackIntegration extends BaseLegacyIntegration {
  readonly type: 'slack'
  configureUrl: string | null
  channel: string | null
}

export class SlackIntegrationModel extends BaseLegacyIntegrationModel<RawSlackIntegration> {
  constructor(
    integrationStore: IntegrationStore,
    attrs: Partial<RawSlackIntegration> = {},
  ) {
    const initialValues: RawSlackIntegration = {
      id: '',
      type: 'slack',
      events: {},
      phoneNumberId: null,
      createdAt: null,
      configureUrl: null,
      channel: null,
    }

    super(integrationStore, initialValues, attrs)
  }

  get type(): 'slack' {
    return this.raw.type
  }

  get configureUrl(): string | null {
    return this.raw.configureUrl
  }

  get channel(): string | null {
    return this.raw.channel
  }
}

export const isSlackIntegrationModel = (a: unknown): a is SlackIntegrationModel => {
  return a instanceof SlackIntegrationModel
}
